const TopStory = () => import('@/views/market/competitors/TopStory')
const MediaCompetitor = () => import('@/views/market/competitors/MediaCompetitor');

const mainWidget = [
  {
    title: 'Content ที่ได้รับ engagement สูงสุด',
    path: '/admin/widget/:category/:widget_code(57)',
    component: TopStory
  },
  {
    title: 'กราฟแท่งแสดงปริมาณการโพสผ่านช่องทางต่างๆ เปรียบเทียบระหว่างประเทศ',
    path: '/admin/widget/:category/:widget_code(58)',
    component: MediaCompetitor
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})